var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIncrease = function SvgIncrease(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9,
    height: 10,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#increase_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#33FF85",
    d: "M8.034 7.395H.766q-.385-.025-.52-.35-.136-.323.118-.618l3.634-3.659a.57.57 0 0 1 .402-.172.57.57 0 0 1 .402.172l3.634 3.659q.255.295.119.619t-.52.349"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "increase_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.2 9.2h8.4V.8H.2z"
  })))));
};
export default SvgIncrease;